import { Box, Text } from '@factorialco/deprecated-design-system'
import { Button } from '@factorialco/factorial-one-react'
import { IconAvatar } from '@factorialco/factorial-one-react/dist/experimental'
import { Pencil } from '@factorialco/factorial-one-react/icons/app'
import { FormsElementTypeEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { HeaderSidebarDropdown } from '../dropdowns'

export const EmptyState = ({
  onAddElement,
}: {
  onAddElement: (type: FormsElementTypeEnum, sectionId: string | null) => void
}) => {
  return (
    <Box justifyContent="center" alignItems="center" height="full" gap="s12">
      <IconAvatar icon={Pencil} size="lg" />
      <Text.Header2>{i18n.t('forms.editor.empty_state.title')}</Text.Header2>
      <Text.Normal>{i18n.t('forms.editor.empty_state.description')}</Text.Normal>
      <Box flexDirection="row" gap="s12">
        <HeaderSidebarDropdown onAddElement={onAddElement} />
        <Button label={'Generate'} variant="outline" size="md" />
      </Box>
    </Box>
  )
}
